import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { getRandomNumber } from '../../utilities/math/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { AlignmentTypes } from '../image-block/types.js';
import '../../molecules/lightbox/index.js';
import { StyleTypes } from '../text-block/types.js';
import { VideoTypes } from '../../molecules/video-player/types.js';
import img from './assets/skip_previous.svg.js';
import img$1 from './assets/skip_next.svg.js';
import css_248z from './video-block.scss.js';

class VideoBlock extends s {
    constructor() {
        super(...arguments);
        this.closeButtonText = 'Close';
        this.styleType = StyleTypes.GREY;
        this.buttonAriaLabel = 'Play video';
        this.autoplay = false;
        this.insideTitle = true;
        this.layout = 'right';
        this.visibleButtons = false;
        this.forceAspectRatio = false;
        this.thumbnailIsVisible = true;
        this.insideTextBlock = false;
        this.insideVideoGallery = false;
        this._videoPlayer = this.querySelector('video-player');
        this._id = null;
    }
    showLightbox() {
        this.shadowRoot.querySelector('light-box').setAttribute('show', 'true');
    }
    runVideo() {
        var _a, _b;
        if (this._videoPlayer.type === VideoTypes.LOCAL) {
            if (this.thumbnailIsVisible) {
                (_b = (_a = this._videoPlayer.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('video')) === null || _b === void 0 ? void 0 : _b.play();
            }
        }
        else {
            this._videoPlayer.autoplay = true;
        }
    }
    showInlineVideo() {
        var _a;
        this.thumbnailIsVisible = false;
        if (this._videoPlayer)
            this.removeTabIndex();
        (_a = this.shadowRoot.querySelector('.video-block')) === null || _a === void 0 ? void 0 : _a.classList.remove('gradient');
    }
    removeTabIndex() {
        this._videoPlayer.removeAttribute('tabindex');
    }
    addTabIndex() {
        this._videoPlayer.setAttribute('tabindex', '-1');
    }
    handleThumbnailClick() {
        var _a, _b;
        this.runVideo();
        this.showInlineVideo();
        const player = (_a = this.renderRoot
            .querySelector('slot[name="inline-video"]')) === null || _a === void 0 ? void 0 : _a.assignedNodes()[0];
        (_b = player.renderRoot.querySelector('video')) === null || _b === void 0 ? void 0 : _b.focus();
    }
    firstUpdated() {
        this._id = `box-${getRandomNumber().toString(16).slice(2)}`;
        const parent = this.parentNode;
        const img = this.querySelector('img');
        if ((parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'text-block')
            this.insideTextBlock = true;
        if (parent === null || parent === void 0 ? void 0 : parent.classList.contains('gallery-container-videos'))
            this.insideVideoGallery = true;
        if (this.insideTextBlock)
            img === null || img === void 0 ? void 0 : img.classList.add('insideTextBlock');
        if (this._videoPlayer)
            this.addTabIndex();
        this.applySlotStyles();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('insideTitle')) {
            this.applySlotStyles();
        }
    }
    applySlotStyles() {
        var _a, _b;
        const textSlot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="text"]');
        const captionSlot = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('slot[name="caption"]');
        if (!textSlot || !captionSlot)
            return;
        const textNodes = textSlot.assignedNodes({ flatten: true }) || [];
        const captionNodes = captionSlot.assignedNodes({ flatten: true }) || [];
        textNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                element.style.color = !this.insideTitle ? '#512573' : '';
                element.style.fontFamily = '"Noto Sans"';
                element.style.fontSize = '20px';
                element.style.fontStyle = 'normal';
                element.style.fontWeight = '700';
                element.style.lineHeight = '30px';
                element.style.margin = '0';
                element.style.textAlign = 'left';
            }
        });
        captionNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node;
                element.style.color = '#333';
                element.style.fontFamily = 'Noto Sans';
                element.style.fontSize = '16px';
                element.style.fontStyle = 'normal';
                element.style.fontWeight = '400';
                element.style.lineHeight = '24px';
                element.style.margin = '0';
                element.style.textAlign = 'left';
            }
        });
    }
    render() {
        const styleClass = `style-${this.styleType}`;
        const isFullWidth = this.alignment === AlignmentTypes.FULL_WIDTH;
        const isNoneAlignment = this.alignment === AlignmentTypes.NONE;
        const lightbox = !isFullWidth && !isNoneAlignment
            ? x `<light-box id="${this._id}" closeButtonText="${this.closeButtonText}"><div slot="content"><slot name="lightbox-video"></slot></div></light-box>`
            : null;
        return x `<div class="video-text-container ${this.layout} ${this.forceAspectRatio
            ? 'force-aspect-ratio'
            : ''}"><div class="video-container"><div class="video-block gradient ${this.alignment} ${this.rtl || isRTL()
            ? 'rtl'
            : ''} ${this.insideTextBlock ? 'insideTextBlock' : ''} ${this
            .insideVideoGallery
            ? 'insideVideoGallery'
            : ''}"><button type="button" aria-label="${this.buttonAriaLabel}" data-target="${this._id}" class="thumbnail ${!this.thumbnailIsVisible
            ? 'hide'
            : ''} ${styleClass}" @click="${() => {
            if (isFullWidth || isNoneAlignment) {
                this.handleThumbnailClick();
            }
            else {
                this.showLightbox();
            }
        }}"><slot name="thumbnail"></slot><div class="video-controls"><div class="play"><svg class="play-icon" width="50" height="64" viewBox="0 0 50 64" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="icon-gradient" x1="3" y1="3" x2="11.3747" y2="65.7543" gradientUnits="userSpaceOnUse"><stop stop-color="#6f2595"/><stop offset="1" stop-color="#aa0061"/></linearGradient></defs><path d="M47 32L48.6509 29.4951C49.4931 30.0502 50 30.9913 50 32C50 33.0087 49.4931 33.9498 48.6509 34.5049L47 32ZM4.65094 63.5049C3.26753 64.4167 1.40691 64.0343 0.495124 62.6509C-0.416665 61.2675 -0.0343452 59.4069 1.34906 58.4951L4.65094 63.5049ZM3 3L1.19209e-06 3C1.47875e-06 1.89645 0.605871 0.88199 1.57747 0.35871C2.54907 -0.164569 3.72952 -0.112175 4.65094 0.495125L3 3ZM6 32L6 35L-1.39876e-06 35L-1.26763e-06 32L6 32ZM48.6509 34.5049L4.65094 63.5049L1.34906 58.4951L45.3491 29.4951L48.6509 34.5049ZM45.3491 34.5049L1.34906 5.50487L4.65094 0.495125L48.6509 29.4951L45.3491 34.5049ZM6 3L6 32L-1.26763e-06 32L1.19209e-06 3L6 3Z" fill="none"/></svg></div>${this.insideTitle ? x `<slot name="text"></slot>` : ''}</div><slot name="description"></slot><slot name="inline-video"></slot></button> ${lightbox}</div></div><div class="text-container"><slot name="text"></slot><slot name="caption"></slot>${this.visibleButtons
            ? x `<div class="button-container"><button class="nav-button prev"><img src="${img}" alt="Previous"> <span>Previous</span></button> <button class="nav-button next"><span>Next</span> <img src="${img$1}" alt="Next"></button></div>`
            : ''}</div></div>`;
    }
}
VideoBlock.styles = css_248z;
__decorate([
    n({ type: String })
], VideoBlock.prototype, "alignment", void 0);
__decorate([
    n({ type: Boolean })
], VideoBlock.prototype, "rtl", void 0);
__decorate([
    n()
], VideoBlock.prototype, "closeButtonText", void 0);
__decorate([
    n({ type: String })
], VideoBlock.prototype, "styleType", void 0);
__decorate([
    n({ type: String })
], VideoBlock.prototype, "buttonAriaLabel", void 0);
__decorate([
    n({ type: Boolean })
], VideoBlock.prototype, "autoplay", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], VideoBlock.prototype, "insideTitle", void 0);
__decorate([
    n({ type: String, reflect: true })
], VideoBlock.prototype, "layout", void 0);
__decorate([
    n({ type: Boolean })
], VideoBlock.prototype, "visibleButtons", void 0);
__decorate([
    n({ type: Boolean })
], VideoBlock.prototype, "forceAspectRatio", void 0);
__decorate([
    t()
], VideoBlock.prototype, "thumbnailIsVisible", void 0);
__decorate([
    t()
], VideoBlock.prototype, "insideTextBlock", void 0);
__decorate([
    t()
], VideoBlock.prototype, "insideVideoGallery", void 0);
customElements.define('video-block', VideoBlock);

export { VideoBlock };
